import { render, staticRenderFns } from "./crudReport.vue?vue&type=template&id=6ba4ac0d&scoped=true&"
import script from "./crudReport.vue?vue&type=script&lang=js&"
export * from "./crudReport.vue?vue&type=script&lang=js&"
import style0 from "./crudReport.vue?vue&type=style&index=0&id=6ba4ac0d&prod&lang=css&"
import style1 from "./crudReport.vue?vue&type=style&index=1&id=6ba4ac0d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba4ac0d",
  null
  
)

export default component.exports